var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.close($event)}}},[_c('div',{staticClass:"card"},[_c('sign-up-form',{on:{"close":_vm.close}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }